(function () {
    'use strict';
    var controllerId = 'codiceClasse';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'classe', codiceClasseFn]);

    function codiceClasseFn($scope, $uibModalInstance, classe) {
        $scope.item = {};
        $scope.item.classe = classe;
        
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();